import styled from "@emotion/styled";

const Title = styled.h1`
  text-align: center;
  /* color: yellow; */
`;

export { Title };
